module.exports = __webpack_public_path__ + "img/table-remove-user-icon.bc78d427.svg";